// just putting an extremely basic email verification here..
// anything more advanced could lead to more bugs then it solves
// => true email verification should be happening on the backend
export const validateEmailSyntax = (email) => /\S+@\S+\.\S+/.test(email);
